module.exports = __webpack_public_path__ + "img/artrade-logo-only-min.2f025a8c.png";